"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function isObject(x) {
  return x !== null && typeof x === 'object';
}

exports.isObject = isObject;